import React from "react";
import { InstallAppButton } from "@/components/InstallAppButton";
import { SealCheck, FileArrowDown, SignIn } from "@phosphor-icons/react";

export function StepDone({ token, state }) {
  const email = state.wizard.contact?.email || state.email;
  return (
    <div className="text-center py-6" data-testid="ob-done">
      <div className="w-20 h-20 mx-auto rounded-full bg-emerald-400/15 grid place-items-center"><SealCheck size={46} weight="fill" className="text-emerald-400" /></div>
      <h2 className="font-heading font-extrabold text-4xl text-white mt-6 tracking-tight">You're All Set</h2>
      <p className="text-white/60 mt-3 max-w-lg mx-auto">Your agreement is signed and your profile is with our authorization team. You'll be assigned a dedicated dispatcher shortly.</p>
      <div className="mt-10 rounded-3xl border border-white/10 bg-white/[0.03] p-6 sm:p-8 max-w-xl mx-auto text-left">
        <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-sky-400">Get the Asterism Carrier App</p>
        <p className="text-white/70 mt-2 text-sm">Track loads, documents, invoices and your agreement. Log in with <b className="text-white">{email}</b> and your phone number. On first login you'll create your password.</p>
        <div className="mt-5 flex flex-wrap gap-3">
          <InstallAppButton />
          <a href="/carrier-setup" className="inline-flex items-center gap-2 h-12 px-6 rounded-full border border-white/20 text-white font-semibold hover:border-white/40 transition-colors" data-testid="ob-open-app"><SignIn size={18} />Open Carrier App</a>
          <a href={`${process.env.REACT_APP_BACKEND_URL}/api/onboard/${token}/agreement.pdf`} className="inline-flex items-center gap-2 h-12 px-6 rounded-full border border-white/20 text-white/80 hover:text-white hover:border-white/40 transition-colors" data-testid="ob-download-agreement"><FileArrowDown size={18} />Agreement PDF</a>
        </div>
      </div>
    </div>
  );
}
